module.exports = __webpack_public_path__ + "img/pizzas.f3104b6.jpg";